const t=t=>{const[,r,e]=/(.*)\.(prop|attr)$/.exec(t)||[,t,"rest"];return{trimmedKey:r,category:e}},r=t=>"string"==typeof t||null==t?t:JSON.stringify(t);export{r as transformAttrValue,t as transformKey};
//# sourceMappingURL=utils.js.map
